import { Injectable, OnDestroy } from '@angular/core';
import { environment } from '@env/environment';
import {
  IgetInputSheetRequest,
  IPostInputSheetRequest,
} from '@interface/InputSheet';
import { BehaviorSubject } from 'rxjs';
import { ApiUtils } from '@core/services/Utils/apiUtils';
import {
  downloadInstructionFile,
  get,
  post,
} from '@core/interceptors/fetch-client';

@Injectable({
  providedIn: 'root',
})
export class InputSheetService implements OnDestroy {
  private selectedDateSubject = new BehaviorSubject<string>('');
  private inputSheetDataSubject = new BehaviorSubject<any | null>(null);
  readonly selectedDate$ = this.selectedDateSubject.asObservable();
  readonly inputSheetData$ = this.inputSheetDataSubject.asObservable();

  constructor() {}

  updateSelectedDate(val: string) {
    this.selectedDateSubject.next(val);
  }

  updateInputSheetData(val: any | null) {
    this.inputSheetDataSubject.next(val);
  }

  async getInputSheetData(request: IgetInputSheetRequest): Promise<any> {
    let response = null;
    const isLocalhost = window.location.hostname === 'localhost';
    let url = `${environment.getInputSheetDataUrl}?stmt_month=${request.stmt_month}&stmt_year=${request.stmt_year}&template=${request.template}`;
    if (isLocalhost) {
      url += `&code=${environment.functionappCode}`;
    }
    await ApiUtils.handleApiResponse1(
      get<any>(url, {}, true), // <-- Pass `true` for Python Web API
      (data, statusCode) => {
        response = { data, statusCode };
      },
      'Failed to fetch InputSheet data:',
    );

    return response || { message: 'Failed to fetch InputSheet data:' };
  }

  async postInputSheetData(request: IPostInputSheetRequest): Promise<any> {
    let response = null;
    const isLocalhost = window.location.hostname === 'localhost';
    let url = `${environment.uploadInputSheetDataUrl}`;
    if (isLocalhost) {
      url += `?code=${environment.functionappCode}`;
    }
    await ApiUtils.handleApiResponse(
      post<any>(url, request, {}, true), // ✅ Pass `true` here
      (data) => {
        response = data;
      },
      'Failed update InputSheet data:',
    );

    return response || { message: 'Failed update InputSheet data:' };
  }

  async getInstructionsDetails(): Promise<void> {
    let url = environment.getInputSheetInstructionsUrl;
    if (window.location.hostname === 'localhost') {
      url += `?code=${environment.functionappCode}`;
    }
    await downloadInstructionFile(url, true);
  }

  ngOnDestroy() {
    this.selectedDateSubject.complete();
    this.inputSheetDataSubject.complete();
  }
}
